import { ProductCatalogItemSummaryFragment } from '@graphql/generated';

export const clipTextWithElipsis = (text: string, maxLength: number) => {
  return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
};

export const getProductTileDisplayFields = (
  product: Pick<ProductCatalogItemSummaryFragment, 'id' | 'brand' | 'title' | 'photos' | 'price' | 'fullPrice' | 'isFullPrice' | 'tags'>,
) => {
  return {
    id: product.id,
    brand: product.brand?.name,
    title: product.title,
    price: product.price,
    fullPrice: product.fullPrice,
    photoUrl: product.photos[0]?.url,
    isFullPrice: product.isFullPrice,
    tags: product.tags,
  };
};
